var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('Lightbox',{attrs:{"escDisabled":"","moveDisabled":"","visible":_vm.visible,"imgs":_vm.imgs,"index":_vm.index},on:{"hide":_vm.handleHide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }